import { Navigate, Route, Routes } from 'react-router-dom';

import MainLayout from 'src/components/layout/MainLayout';
import { PERMISSION } from 'src/features/auth';
import ReservationDetails from 'src/features/reservations/components/ReservationDetails';
import VehicleSubscriptionDetails from 'src/features/subscriptions/components/VehicleSubscriptionDetails';
import VehiclesLayout from 'src/features/vehicles/components/VehiclesLayout';
import FullLog from 'src/features/vehicles/routes/FullLog';
import InParking from 'src/features/vehicles/routes/InParking';
import { MembershipGroup } from 'src/features/vehicles/routes/MembershipGroup';
import Memberships from 'src/features/vehicles/routes/Memberships';
import Reservations from 'src/features/vehicles/routes/Reservations';
import Subscriptions from 'src/features/vehicles/routes/Subscriptions';
import useHasPermissions from 'src/hooks/useHasPermissions';

const VehicleRoutes = () => {
    const permissionVehicle = useHasPermissions([PERMISSION.VEHICLE]);
    const permissionStay = useHasPermissions([PERMISSION.VEHICLE_STAY]);
    const permissionMembership = useHasPermissions([PERMISSION.VEHICLE_MEMBERSHIP]);
    const permissionFullLog = useHasPermissions([PERMISSION.VEHICLE_FULL_LOG]);
    const permissionReservations = useHasPermissions([PERMISSION.RESERVATIONS]);
    const permissionSubscriptions = useHasPermissions([PERMISSION.SUBSCRIPTIONS]);

    return permissionVehicle ? (
        <Routes>
            <Route
                path="memberships/:membershipGroupId"
                element={
                    <MainLayout>
                        <MembershipGroup />
                    </MainLayout>
                }
            />
            <Route path="" element={<VehiclesLayout />}>
                {permissionStay && <Route path="" element={<InParking />} />}
                {permissionMembership && <Route path="memberships" element={<Memberships />} />}
                {permissionFullLog && <Route path="full-log" element={<FullLog />} />}
                {permissionReservations && <Route path="reservations" element={<Reservations />} />}
                {permissionSubscriptions && <Route path="subscriptions" element={<Subscriptions />} />}
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
            {permissionSubscriptions && (
                <Route path="subscriptions/:subscriptionId" element={<VehicleSubscriptionDetails />} />
            )}
            {permissionReservations && <Route path="reservations/:reservationId" element={<ReservationDetails />} />}
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default VehicleRoutes;
